import { render, staticRenderFns } from "./endetfripro.vue?vue&type=template&id=4c292cdd&scoped=true&"
import script from "./endetfripro.vue?vue&type=script&lang=js&"
export * from "./endetfripro.vue?vue&type=script&lang=js&"
import style0 from "./endetfripro.vue?vue&type=style&index=0&id=4c292cdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c292cdd",
  null
  
)

export default component.exports